export default __webpack_public_path__ + "static/media/login.a9f29917.webp";